import React, { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useNavigate, Navigate, NavLink, Outlet } from 'react-router-dom';
import axios from 'axios';

import ButtonRegular from './ui/ButtonRegular';
import '../styles/AdminControlPanel.css';

const AdminControlPanel = () => {
    const { logout } = useContext(AuthContext);
    const [userDetails, setUserDetails] = useState(null);
    const navigate = useNavigate();

    // Sprawdzanie uprawnień administratora
    useEffect(() => {
        const fetchUserDetails = async () => {
            const token = localStorage.getItem('authToken');
            if (!token) {
                navigate('/login');
                return;
            }
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_URL}/api/users/user`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                setUserDetails(response.data);
            } catch (error) {
                console.error('Błąd autoryzacji w panelu admina', error);
                logout();
                navigate('/login');
            }
        };
        fetchUserDetails();
    }, [logout, navigate]);

    const handleLogout = () => {
        logout();
        navigate('/login'); // Zastąpiono window.location.href bezpieczniejszym navigate
    };

    if (!userDetails) return <p>Weryfikacja uprawnień...</p>;

    if (userDetails.role !== 'admin') {
        return <Navigate to="/" replace />;
    }

    return (
        <div className="admin-panel">
            {/* Sidebar z menu */}
            <nav className="sidebar">
                <h2>Panel Administratora</h2>
                <ul>
                    <li>
                        {/* 'end' sprawia, że klasa active jest dodawana tylko dla dokładnego adresu /admin */}
                        <NavLink to="/admin" end className={({ isActive }) => isActive ? 'active' : ''}>
                            📦 Zarządzanie produktami
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/admin/forms" className={({ isActive }) => isActive ? 'active' : ''}>
                            📄 Formularze
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/admin/orders" className={({ isActive }) => isActive ? 'active' : ''}>
                            🧾 Zamówienia
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/admin/users" className={({ isActive }) => isActive ? 'active' : ''}>
                            👥 Zarządzanie użytkownikami
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/admin/settings" className={({ isActive }) => isActive ? 'active' : ''}>
                            ⚙️ Zarządzanie kategoriami i kolorami
                        </NavLink>
                    </li>
                </ul>
                <ButtonRegular onClick={handleLogout}>🚪 Wyloguj się</ButtonRegular>
            </nav>

            <main className="admin-content">
                <Outlet />
            </main>
        </div>
    );
};

export default AdminControlPanel;